export enum ImageSize {
    Small = 0,
    Medium = 1,
    Large = 2,
}

export const IMAGE_SIZE_OPTIONS: Record<ImageSize, string> = {
    [ImageSize.Small]: "-small",
    [ImageSize.Medium]: "-medium",
    [ImageSize.Large]: "-large",
};
